import { render, staticRenderFns } from "./ProjectAuditLogDraftTab.vue?vue&type=template&id=20a0d36c&scoped=true&lang=html&"
import script from "./ProjectAuditLogDraftTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectAuditLogDraftTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAuditLogDraftTab.vue?vue&type=style&index=0&id=20a0d36c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0d36c",
  null
  
)

export default component.exports